import { Link } from "react-router-dom";
import { RouteFactory } from "@app/routePaths";
import { TestIdClassNameProps } from "@app/types/Common";
import Button from "@components/AccessibleComponents/Button";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type NewsletterFormTriggerProps = TestIdClassNameProps & {
  setShowForm: (show: boolean) => void;
  showViewAll?: boolean;
};

export const NewsletterFormTrigger = ({
  testId,
  setShowForm,
  showViewAll = false,
}: NewsletterFormTriggerProps) => {
  return (
    <div className="relative" data-testid={testId}>
      <Button
        className="mr-2 cursor-pointer whitespace-nowrap rounded-full bg-gray-850 px-8 py-1.5 text-center text-base text-white hover:bg-gray-675"
        onPress={() => {
          setShowForm(true);
        }}
      >
        Sign Up
      </Button>

      {showViewAll ? (
        <Link
          to={RouteFactory.newsletterSignup}
          className="whitespace-nowrap pl-4 text-base font-semibold !text-gray-850 hover:!no-underline"
          target="_blank"
          reloadDocument
        >
          VIEW ALL
          <FontAwesomeIcon icon={faChevronRight} size="xs" className="ml-1" />
        </Link>
      ) : null}
    </div>
  );
};
